import { type IDropdownItem } from 'shared/ui'
import { type IInboxTreeCombine } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeTeamsFavorite = 'favorite'

type IActionTeamsFavorite = {
  inbox: IInboxTreeCombine
  item: IDropdownItem
}

export const menuTeamsFavorite = (inbox: IInboxTreeCombine): IDropdownItem => {
  return {
    id: typeTeamsFavorite,
    iconL: inbox.isFavoriteType ? 'starFilled1' : 'starLine',
    label: inbox.isFavoriteType ? 'Unfavorite' : 'Favorite',
  }
}

export const actionTeamsFavorite = (
  { inbox, item }: IActionTeamsFavorite,
  store: ConversationMenuStore
) => {
  if (item.id === typeTeamsFavorite) {
    store.updateFavorite({
      inbox: inbox,
      status: !inbox.isFavoriteType,
    })
  }
}
